import React, { useState } from 'react';
import { makeStyles, styled } from '@mui/styles';

import {
  Box, Typography,
  Modal,
  Button,
} from '@mui/material';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import AlertDialog from '../../AlertDialog';

import { parseValidationErrorMessage } from '../../../utils/Utilities';
import { OrganizationBranchesBulkUpload } from '../../../network/Organization'
import { useAuth } from '../../customContextProviders/AuthContext';



const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "190px"
  },
});


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 300,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});






export default function AddOrganiationBranchesModal({ opneAssignedModal, handleClose, onAction, organizationData }) {

  const { sessionUserData } = useAuth()
  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });


  const handleFileUpload = (event) => {

    OrganizationBranchesBulkUpload(event.target.files[0],
      organizationData !== undefined && organizationData !== null ? organizationData?.id : sessionUserData?.user?.organizationId
    ).then((_res) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: "Branches have been successfully added !", title: "Processed Successfully", btnLabel: "OK" });
      setOpenAlertDialog(true)

    }).catch((error) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error), title: "Error processing the file", btnLabel: "OK" });
      setOpenAlertDialog(true)

    })
  }


  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid='upload-branches'
      >

        <Box sx={style}>
          <Typography sx={{ fontSize: 18, fontWeight: 900 }}>Upload Branches  </Typography>

          <Button sx={{ mt: 3 }} component="label" variant="contained" startIcon={<CloudUploadIcon />}>
            Select  File
            <VisuallyHiddenInput onChange={handleFileUpload} type="file" accept='.csv' />
          </Button>


        </Box>

      </Modal>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />

    </Box>
  );
}
